import SavingTracker from 'features/accounts/SavingsTracker/SavingsTracker';
import React from 'react';
import { PinwheelContextProvider } from 'shared/providers/pinwheel/PinwheelContextProvider/PinwheelContextProvider';

export default function SavingTrackerPage() {
  return (
    <PinwheelContextProvider>
      <SavingTracker />
    </PinwheelContextProvider>
  );
}
